"use strict";

export const Throttler = function(wait = 1, fn) {
	this.wait = wait;
	this.fn = fn;
	this.dt = 0;
}

Throttler.prototype.update = function(dt) {
	this.dt += dt;
	while(this.dt > this.wait) {
		if (_.isFunction(this.fn)) {
			this.fn(this.wait);
		}
		this.dt -= this.wait;
	}
}


/** WEBPACK FOOTER **
 ** ./~/jshint-loader!./src/util/Throttler.js
 **/